import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=425a48e9&scoped=true&lang=pug"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.styl?vue&type=style&index=0&id=425a48e9&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425a48e9",
  null
  
)

export default component.exports